<nz-modal
  [nzVisible]="settingVisible"
  [nzWidth]="980"
  [nzTitle]="'图片采集'"
  [nzFooter]="null"
  [nzMaskClosable]="false"
  (nzOnCancel)="handleCloseHSCModal()"
>
  <div class="modal-main-content">
    <div class="hsc-content">
      <div class="hsc-img-area">
        <div class="img-area"><img id="view1" [src]="mainCameraUrl" /></div>
        <div class="options-area">
          <div (click)="cameraScan(0, isDeskew ? 1 : 0)">
            <i class="icon iconfont icon-camera"></i>
          </div>
          <div (click)="deskew()"><i class="icon iconfont icon-file-scan"></i></div>
          <div (click)="turnRight()">
            <i class="icon iconfont icon-rotate-right"></i>
          </div>
          <div (click)="turnLeft()"><i class="icon iconfont icon-rotate-left"></i></div>
        </div>
      </div>
      <div class="hsc-img-area">
        <div class="img-area"><img id="view2" [src]="subCameraUrl" /></div>
        <div class="options-area">
          <div (click)="cameraScan(1)"><i class="icon iconfont icon-camera"></i></div>
        </div>
      </div>
    </div>
    <div class="right-content">
      <div class="camera-info">
        <button nz-button nzType="default" (click)="openMainCamera()">开启主摄像</button>
        <button nz-button nzType="default" (click)="closeCamera(0)">关闭主摄像</button>
        <button
          style="visibility: hidden"
          nz-button
          class="modal-cancel-btn"
          (click)="handleCloseHSCModal()"
        >
          关闭
        </button>
        <button nz-button nzType="default" (click)="openSubCamera()">开启副摄像</button>
        <button nz-button nzType="default" (click)="closeCamera(1)">关闭副摄像</button>
        <button
          nz-button
          nzType="primary"
          [disabled]="imgPathArray.length < 1"
          (click)="exportFiles()"
        >
          上传
        </button>
      </div>
      <div class="file-list-area">
        <div *ngFor="let item of imgPathArray; let i = index" class="hsc-thumb">
          <div class="hsc-img-box" (click)="openPreview(i)">
            <img [src]="item.src" />
          </div>
          <div>
            <nz-select style="width: 130px; margin-top: 2px" [(ngModel)]="item.fileType">
              <nz-option
                *ngFor="let option of fileTypeList"
                [nzValue]="option.wordValue"
                [nzLabel]="option.wordText"
              ></nz-option>
            </nz-select>
          </div>
          <div class="hsc-delete" (click)="deleteFile(i)">
            <i class="icon iconfont icon-close"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</nz-modal>

<nz-modal
  [nzVisible]="downloadModalVisible"
  [nzWidth]="720"
  [nzTitle]="'图片采集'"
  [nzFooter]="downloadModalFooter"
  [nzMaskClosable]="false"
  (nzOnCancel)="handleCloseDownloadModal()"
>
  <p>如果您之前安装过高拍仪驱动，请尝试重新启动高拍仪驱动(WebCamera)。</p>
  <p>
    如果您之前没有安装过，<a href="https://console.box.lenovo.com/l/F5aW4f" target="_blank"
      >点此处下载安装</a
    >
  </p>
</nz-modal>

<ng-template #downloadModalFooter>
  <button nz-button nzType="primary" (click)="handleCloseDownloadModal()">关闭</button>
</ng-template>
